var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAtivo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ativo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x32_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1395",
    "data-name": "Caminho 1395",
    d: "M11.25,1.25a2.5,2.5,0,0,1,2.5,2.5v7.5a2.5,2.5,0,0,1-2.5,2.5H3.75a2.5,2.5,0,0,1-2.5-2.5V3.75a2.5,2.5,0,0,1,2.5-2.5Zm0-1.25H3.75A3.75,3.75,0,0,0,0,3.75v7.5A3.75,3.75,0,0,0,3.75,15h7.5A3.75,3.75,0,0,0,15,11.25V3.75A3.75,3.75,0,0,0,11.25,0Z",
    fill: "#4b9c55"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_",
    transform: "translate(3.813 5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1396",
    "data-name": "Caminho 1396",
    d: "M8.511,13.625a.625.625,0,0,1-.437-.179L6.288,11.7a.625.625,0,0,1,.875-.893l1.348,1.322,4.026-3.946a.625.625,0,0,1,.876.892L8.948,13.446a.625.625,0,0,1-.437.179Z",
    transform: "translate(-6.1 -8)",
    fill: "#4b9c55"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtivo);
export default __webpack_public_path__ + "static/media/ativo.6d5b05bbf742b5973c98885e72443f08.svg";
export { ForwardRef as ReactComponent };